import React from 'react'

import XIcon from '../Icons/XIcon';

import * as S from './styled'

const Tooltip = ({ text, onClose }) => {
  return (
    <S.Container>
      <S.Content>{text?.replace('\n', ' \n\n ')}</S.Content>
      <S.CloseBtn onClick={() => onClose()} data-testid="close-btn">
        <XIcon width="16px" height="16px" />
      </S.CloseBtn>
    </S.Container>
  );
};

export default Tooltip;